// theme.js
const breakpoints = [
    '570px',
    '1024px',
    '1280px',
]

breakpoints.tablet = breakpoints[1] 
breakpoints.desktop = breakpoints[2] 
breakpoints.larger = breakpoints[3]

export default {
    breakpoints,
}